import { makeStyles } from "@material-ui/core/styles";

export const useFlyerDetailPageFormTemplateGroupStyles = makeStyles(() => ({
  accordion: {
    "&::before": {
      backgroundColor: "transparent",
    },

    "&.Mui-disabled": {
      backgroundColor: "transparent",
    },

    "&.Mui-expanded": {
      margin: 0,
    },

    "& >.MuiAccordionSummary-root": {
      "&.Mui-disabled": {
        opacity: 1,
      },

      "& >.MuiAccordionSummary-content": {
        "&.Mui-expanded": {
          margin: "12px 0",
        },
      },
    },

    "& >.MuiCollapse-container": {
      minHeight: "182px !important",

      "&.MuiCollapse-hidden": {
        visibility: "visible",
      },
    },
  },

  templates: {
    display: "flex",
    flexWrap: "wrap",
    paddingBottom: 0,
  },
}));
export const minHeight = 200;
